import { SANS_2, SANS_3, colors2, getText } from 'oolib';
import * as Typo2 from 'oolib/dist/v2/components/Typo2';
import React from 'react';

import { formatters } from '../utils/formatters';

const TableText = ({
    value: _value, 
    tableRowData, 
    typoComp = 'UI_BODY_SM_DF', // any Typo2 export by name (UI_BODY_SEMIBOLD_SM, UI_CAPTION, ...) or the legacy SANS_2 / SANS_3
    color,
    suffix,
    formatter,
    highlight, // optional search term: case-insensitive matches get a marker background
    ...typoCompProps
}) => {
    
    
    // ensures that if value doesnt exist or rich text data has not text, then dont return the comp
    // so the table elem defaults to showing a  '-'
    if(!_value || (_value.blocks && _value.blocks.length === 0) ) return null;

    let comps = { SANS_2, SANS_3 }

    let TYPO_COMP = comps[typoComp] || Typo2[typoComp] || Typo2.UI_BODY_SM_DF;

    

    const value = formatter
        ? formatters[formatter](getText(_value))
        : getText(_value)

    return (
        <TYPO_COMP {...(typoCompProps || {})} style={{ ...(color ? { color } : {}), ...(typoCompProps?.style || {}) }}>
            {highlight ? highlightMatches(`${value}`, highlight) : value}{suffix || ''}
        </TYPO_COMP>
    )

    
}

// Split on the term (escaped, case-insensitive). The capture group keeps the
// matched parts in the array at odd indexes, so they get wrapped in <mark>.
const highlightMatches = (text, term) => {
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.split(new RegExp(`(${escaped})`, 'i')).map((part, i) =>
        i % 2 === 1
            ? <mark key={i} style={{ background: colors2.yellowBG, color: 'inherit' }}>{part}</mark>
            : part
    );
};

export default TableText;